import { SystemStyleObject } from '@chakra-ui/react';

export const typographySpacingBase: SystemStyleObject = {
  '& p + p': {
    marginTop: { base: 5, lg: 6 }, // Use your theme's breakpoints
  },

  '& p + h3, & p + h4, & p + h5, & p + h6, & ul + h3, & ul + h4, & ul + h5, & ul + h6, & ol + h3, & ol + h4, & ol + h5, & ol + h6':
    {
      marginTop: { base: 10, lg: 14 },
    },

  // h4 + p: 12px/16px, h5 + p: 8px/12px, h6 + p: 8px all breakpoints
  '& h3 + p, & h4 + p': {
    marginTop: { base: 3, lg: 4 }, // 12px/16px
  },
  '& h5 + p': {
    marginTop: { base: 2, lg: 3 }, // 8px/12px
  },
  '& h6 + p': {
    marginTop: 2, // 8px all breakpoints
  },

  // h3 + p and all heading + ul/ol: keep previous logic
  '& h3 + ul, & h4 + ul, & h5 + ul, & h6 + ul, & h3 + ol, & h4 + ol, & h5 + ol, & h6 + ol':
    {
      marginTop: { base: 5, lg: 6 }, // 20px/24px
    },

  '& p + ul, & p + ol': {
    marginTop: { base: 5, lg: 6 },
  },

  // Nested ordered lists (an ol inside an li, directly following that li's p)
  // should not inherit the paragraph-to-list top spacing.
  '& li > p + ol': {
    marginTop: 0,
  },

  '& ul + p, & ol + p': {
    marginTop: { base: 5, lg: 6 },
  },

  '& li + li': {
    marginTop: 2,
  },
};

export const typographySpacingFirstChild: SystemStyleObject = {
  '& > p:first-child': {
    marginTop: { base: 5, lg: 6 },
  },
  '& > h3:first-child, & > h4:first-child, & > h5:first-child, & > h6:first-child':
    {
      marginTop: { base: 10, lg: 14 },
    },
};
